<template>
  <v-container style="max-width: 800px" class="py-8">
    <c-loader-status :loaders="[loader] as any">
      <h1 class="text-h5 font-weight-bold mb-6">{{ terms?.title }}</h1>
      <v-card variant="outlined" class="pa-6">
        <p class="text-body-1" style="white-space: pre-wrap; line-height: 1.8">
          {{ terms?.content }}
        </p>
      </v-card>
    </c-loader-status>
  </v-container>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from "vue";
import { useTitle } from "@common/composables/useTitle";
import { getTicketGoatTerms, type TermsResponse } from "../api/termsApi";

const terms = ref<TermsResponse | null>(null);
const loader = reactive({
  isLoading: true,
  wasSuccessful: null as boolean | null,
  message: null as string | null,
  hasResult: false,
});

useTitle("Ticket Goat's Terms and Conditions");

onMounted(async () => {
  try {
    terms.value = await getTicketGoatTerms();
    loader.wasSuccessful = true;
    loader.hasResult = true;
  } catch {
    loader.wasSuccessful = false;
    loader.message =
      "Unable to load terms and conditions. Please try again later.";
  } finally {
    loader.isLoading = false;
  }
});
</script>
